import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAspectRatio23 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M16.1992 8C16.1992 7.33726 15.6618 6.7998 14.999 6.7998H8.99902C8.33628 6.7998 7.79883 7.33726 7.79883 8V16C7.79883 16.6627 8.33628 17.2002 8.99902 17.2002H14.999C15.6618 17.2002 16.1992 16.6627 16.1992 16V8ZM17.7988 16C17.7988 17.5464 16.5454 18.7998 14.999 18.7998H8.99902C7.45263 18.7998 6.19922 17.5464 6.19922 16V8C6.19922 6.4536 7.45263 5.2002 8.99902 5.2002H14.999C16.5454 5.2002 17.7988 6.4536 17.7988 8V16Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgAspectRatio23);
export default ForwardRef;
